import { atom } from "recoil"

export const serviceTabAtom = atom({
  key: "serviceTabAtom",
  default: ""
})
